<template>
    <div class="page">
        <van-nav-bar
            title="客户使用指南"
            left-arrow
            fixed
            placeholder
            safe-area-inset-top
            @click-left="goBack"
        />
        <iframe
            class="guide-frame"
            :src="guideUrl"
            title="客户使用指南"
        />
    </div>
</template>

<script>
export default {
    name: 'CustomerUsageGuide',
    data() {
        return {
            guideUrl: '/static-h5/customer-usage-guide.html',
        }
    },
    methods: {
        goBack() {
            this.$router.back()
        },
    },
}
</script>

<style scoped>
.page {
    display: flex;
    flex-direction: column;
    height: 100vh;
    height: 100dvh;
    background: #eef3f9;
    box-sizing: border-box;
}

.guide-frame {
    flex: 1;
    width: 100%;
    border: none;
    background: #eef3f9;
}

.page ::v-deep .van-nav-bar {
    background: #ffffff;
}

.page ::v-deep .van-nav-bar .van-nav-bar__title {
    color: #1e3a5f;
    font-weight: 600;
}

.page ::v-deep .van-nav-bar .van-icon {
    color: #2b7de9;
}
</style>
